<template>
  <div>
    <university-template-index
      :formSearch="formSearch"
      :enableExport="false"
      :hide-action="false"
      :columns="columns"
      :title="$t('menu.university_template_list')"
      :serviceName="serviceName"
    />
  </div>
</template>

<script>
import UniversityTemplateIndex from "./UniversityTemplateIndex";
import { CriterionCategoriesService } from "../../../services/criterionCategories.service";
import { UniversityDivisionService } from "../../../services/universityDivision.service";
import { UniversityTypeService } from "../../../services/universityType.service";

export default {
  name: "Index",
  data() {
    return {
      serviceName: "template",
      formSearch: [
        {
          label: this.$t("university_template.name"),
          name: "name__~",
          value: "",
          type: "input"
        },
        {
          label: this.$t("university_template.university_division_name"),
          name: "university_division_id",
          value: "",
          type: "select",
          options: []
        },
        {
          label: this.$t("university_template.university_type_name"),
          name: "university_type_id",
          value: "",
          type: "select",
          options: []
        }
      ],
      columns: {
        id: this.$t("university_template.id"),
        name: this.$t("university_template.name"),
        university_division_name: this.$t(
          "university_template.university_division_name"
        ),
        university_type_name: this.$t(
          "university_template.university_type_name"
        ),
        created_at: this.$t("university_template.created_at"),
        updated_at: this.$t("university_template.updated_at")
      }
    };
  },
  components: { UniversityTemplateIndex },
  methods: {
    async getUniversityDivisionOptions() {
      const response = await new UniversityDivisionService().getList({
        limit: 1000
      });
      this.formSearch[1].options = response.data || [];
      return response.data;
    },
    async getUniversityTypeOptions() {
      const response = await new UniversityTypeService().getList({
        limit: 1000
      });
      this.formSearch[2].options = response.data || [];
      return response.data;
    }
  },
  created() {
    this.getUniversityDivisionOptions();
    this.getUniversityTypeOptions();
  }
};
</script>
